// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_tX2Qc","menus":"menus_2Zxf-","userInfo":"userInfo_1PlBl","themeLight":"themeLight_1wzB8","themeDark":"themeDark_1hZj7"};